import type { Point } from '../types/contour-definition-array-type';
/**
 * Calculates Euclidean distance between 2 points
 * @param {Point} point1 - first point
 * @param {Point} point2 - second point
 * @returns The Euclidean distance
 *
 */
export function getPointPointDistance(
  point1: Point,
  point2: Point,
  xScale: number = 1,
  yScale: number = 1,
): number {
  if (!point1 || !point2) return 0;
  return Math.sqrt(
    xScale * (point1.x - point2.x) * (xScale * (point1.x - point2.x))
    + yScale * (point1.y - point2.y) * (yScale * (point1.y - point2.y)),
  );
}

/**
 * Get the distance between two points
 * @param point1 - first point
 * @param point2 - second point
 * @returns The distance between the two points
 */
export function getPointPointDistanceArray(
  point1: number[],
  point2: number[],
  xScale: number = 1,
  yScale: number = 1,
): number {
  if (!point1 || !point2) return 0;
  return Math.sqrt(
    xScale * (point1[0] - point2[0]) * (xScale * (point1[0] - point2[0]))
    + yScale * (point1[1] - point2[1]) * (yScale * (point1[1] - point2[1])),
  );
}
